export enum AccountStatus {
    Inactive,
    Draft,
    Routing,
    Void,
    Complete,
    Finalized
}